<template>
    <div>
        <div class="card-body text-center">
            <h4><i class="fas fa-check-circle text-success"></i>&nbsp;Successfully completed.</h4>
        </div>
        <div class="card-body">
            <p class="text-center aboutscroll">
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Open"
    }
</script>

<style scoped>

</style>